export interface DprProgressGridData {
  id: number | string;
  priority: number;
  progressId: number;
  name: string;
  isMandatory: boolean;
  clearedToday: number;
  clearedTotal: number;
  percentComplete: number;
  targetTotal: number;
  targetLeft: number;
  comment: string;

  // used for internal grid computation
  clearedTotalInitialValue: number;
}
